export const userAccess = {
  computed: {
    entities() {
      return ['tpr_batch', 'tpr_item']
    },
    tenant() {
      return this.$auth.tenant
    },
    userId() {
      return this.$auth.user.email
    },
    userData() {
      return this.$auth.user
    },
    userGroups() {
      return this.$auth.userGroups || []
    },
    userPermissions() {
      return this.$auth.permissions || []
    },
    userRelationships() {
      return this.$store.getters.userRelationships
    },
    tprProStores() {
      return this.$store.getters.tprProStores || []
    },
    hasTprProStoreAccess() {
      if (this.$auth.tenant !== 'alliance-retail-group') {
        return false
      }
      return this.tprProStores.length > 0
    },
    userRelatedPartyIds() {
      if (this.userRelationships.length > 0) {
        return this.userRelationships.map(u => u.id)
      }
      return []
    },
    tprProUsers(){
      return this.userGroups.includes('tpr-manager.admin', 'tpr-manager.pro', 'tpr-manager.retailer')
    },
    allAdGroups() {
      return this.$store.getters.adGroups
    },
    limitedAdGroups() {
      return this.allAdGroups.filter(adGroup => {
        if (this.userRelatedPartyIds.includes(adGroup.id)) {
          return adGroup
        }
      })
    },
    userAdGroups() {
      const adGroups = this.adminUser ? this.allAdGroups : this.limitedAdGroups;
      if (adGroups.length > 0) {
        const active_groups = adGroups.filter(group => group.attributes?.AD_GROUP_IS_ACTIVE?.toLowerCase() == "true")
        return active_groups.slice().sort((a, b) => a.name.localeCompare(b.name));
      } else {
        return []
      }
    },
    hasPortalAccess() {
      if ((this.$auth.tenant === 'alliance-retail-group') && (process.env.NODE_ENV === 'production') && this.noProdAccess) {
        return false
      }
      const userGroups = this.userGroups.includes('tpr-pro.retailer')
      const readScopes = this.entities.map(entity => `${entity}:read`)
      return userGroups || readScopes.every(scope => this.userPermissions.includes(scope))
    },
    userAccessiblePortals() {
      const portals = ['ad_planner', 'customer', 'promo', 'item', 'billing', 'tpr', 'partner']
      const isProd = process.env.NODE_ENV === 'production'

      return portals.filter(portal => {
        let readScope = `${portal}:read`
        if (portal === 'billing') {
          readScope = 'billing_batch:read'
        } else if (portal === 'customer') {
          readScope = 'party:read'
        }
        else if (portal === 'tpr') {
          readScope = 'tpr_batch:read'
        }
        else if (portal === 'partner') {
          readScope = 'document:read'
        }
        const canRead = this.userPermissions.includes(readScope)
        if (!canRead) return false

        // Hard deny in all envs
        if (this.userPermissions.includes(`${portal}:no_access`)) return false

        // Deny in prod only (dev allowed) if they have the prod-block flag
        if (isProd && this.userPermissions.includes(`${portal}:no_access_prod`)) return false

        return true
      })
    },
    adminUser() {
      return (
        this.userGroups.includes('tpr-manager.admin') ||
        this.adminPermissions.every(scope =>
          this.userPermissions.includes(scope)
        )
      )
    },
    adminPermissions() {
      return this.$auth.buildScopes(this.entities)
    },
    hasRetailWriteAccess() {
      const scopes = ['tpr-manager:update']
      return scopes.every(scope => this.userPermissions.includes(scope))
    },
    limitAccessByRelatedStores() {
      return this.userPermissions.includes('retail:related_stores')
    },
    noProdAccess() {
      return this.userPermissions.includes('tpr:no_access_prod')
    },
    isARGRetailer() {
      const hasStoreRetailer = this.userGroups.includes('arg-store-retailer')
      const hasOwnerRetailer = this.userGroups.includes('arg-owner-retailer')
      return hasStoreRetailer || hasOwnerRetailer
    }
  }
}
